// extracted by mini-css-extract-plugin
export var base = "_11-0";
export var updateBanner = "_11-1";